(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-network-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'coil-root-coil-network-core'.");
    }
    globalThis['coil-root-coil-network-core'] = factory(typeof globalThis['coil-root-coil-network-core'] === 'undefined' ? {} : globalThis['coil-root-coil-network-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var lazy = kotlin_kotlin.$_$.to;
  var setOf = kotlin_kotlin.$_$.sb;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(UncoordinatedConcurrentRequestStrategy, 'UncoordinatedConcurrentRequestStrategy', UncoordinatedConcurrentRequestStrategy, VOID, VOID, [2]);
  initMetadataForInterface(ConnectivityChecker, 'ConnectivityChecker');
  initMetadataForClass(sam$coil3_network_ConnectivityChecker$0, 'sam$coil3_network_ConnectivityChecker$0', VOID, VOID, [ConnectivityChecker, FunctionAdapter]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(Factory, 'Factory');
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(DefaultCacheStrategy, 'DefaultCacheStrategy', DefaultCacheStrategy, VOID, VOID, [3, 4]);
  initMetadataForClass(SingleParameterLazy, 'SingleParameterLazy');
  initMetadataForObject(UNINITIALIZED, 'UNINITIALIZED');
  //endregion
  function Companion() {
    Companion_instance = this;
    this.exv_1 = new DefaultCacheStrategy();
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.fxv_1 = new UncoordinatedConcurrentRequestStrategy();
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function UncoordinatedConcurrentRequestStrategy() {
  }
  function sam$coil3_network_ConnectivityChecker$0(function_0) {
    this.gxv_1 = function_0;
  }
  protoOf(sam$coil3_network_ConnectivityChecker$0).q3 = function () {
    return this.gxv_1;
  };
  protoOf(sam$coil3_network_ConnectivityChecker$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ConnectivityChecker) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$coil3_network_ConnectivityChecker$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function ConnectivityChecker$Companion$ONLINE$lambda() {
    return true;
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = ConnectivityChecker$Companion$ONLINE$lambda;
    tmp.hxv_1 = new sam$coil3_network_ConnectivityChecker$0(tmp_0);
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function ConnectivityChecker() {
  }
  function NetworkFetcher$Factory$_init_$lambda_9nhdas() {
    return Companion_getInstance().exv_1;
  }
  function NetworkFetcher$Factory$_init_$lambda_9nhdas_0() {
    return Companion_getInstance_0().fxv_1;
  }
  function Factory(networkClient, cacheStrategy, connectivityChecker, concurrentRequestStrategy) {
    var tmp;
    if (cacheStrategy === VOID) {
      tmp = NetworkFetcher$Factory$_init_$lambda_9nhdas;
    } else {
      tmp = cacheStrategy;
    }
    cacheStrategy = tmp;
    var tmp_0;
    if (connectivityChecker === VOID) {
      tmp_0 = ConnectivityChecker$ref();
    } else {
      tmp_0 = connectivityChecker;
    }
    connectivityChecker = tmp_0;
    var tmp_1;
    if (concurrentRequestStrategy === VOID) {
      tmp_1 = NetworkFetcher$Factory$_init_$lambda_9nhdas_0;
    } else {
      tmp_1 = concurrentRequestStrategy;
    }
    concurrentRequestStrategy = tmp_1;
    this.ixv_1 = lazy(networkClient);
    this.jxv_1 = lazy(cacheStrategy);
    this.kxv_1 = singleParameterLazy(connectivityChecker);
    this.lxv_1 = lazy(concurrentRequestStrategy);
  }
  function Companion_2() {
    Companion_instance_2 = this;
    this.mxv_1 = setOf([300, 301, 404, 405, 410, 414, 501]);
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function DefaultCacheStrategy() {
    Companion_getInstance_2();
  }
  function SingleParameterLazy(initializer) {
    this.nxv_1 = initializer;
    this.oxv_1 = UNINITIALIZED_instance;
  }
  function singleParameterLazy(initializer) {
    return new SingleParameterLazy(initializer);
  }
  function UNINITIALIZED() {
  }
  var UNINITIALIZED_instance;
  function UNINITIALIZED_getInstance() {
    return UNINITIALIZED_instance;
  }
  function ConnectivityChecker_0(context) {
    return Companion_getInstance_1().hxv_1;
  }
  function ConnectivityChecker$ref() {
    return constructCallableReference(function (p0) {
      return ConnectivityChecker_0(p0);
    }, 1, 0, 531, 'ConnectivityChecker');
  }
  //region block: init
  UNINITIALIZED_instance = new UNINITIALIZED();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Factory;
  _.$_$.b = Companion_getInstance_0;
  //endregion
  return _;
}));

//# sourceMappingURL=coil-root-coil-network-core.js.map
